import type { ConnectionState } from './../../ricos-context';

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const wrapWithNetworkConditions = <T extends Function>(
  fn: T,
  getDevState: () => ConnectionState
): T =>
  ((...args: any[]) => {
    const devState = getDevState();
    switch (devState.type) {
      case 'BROKEN': {
        const { status, delay, response } = devState;
        return new Promise((_resolve, reject) =>
          setTimeout(() => reject(new MockHttpError({ status, response })), delay * 1000)
        );
      }
      case 'DELAYED': {
        const { delay } = devState;
        return Promise.all([fn(...args), new Promise(r => setTimeout(r, delay * 1000))]).then(
          ([result]) => result
        );
      }
      default: {
        return fn(...args);
      }
    }
  }) as any;

const MOCK_REQUEST_ID = 'requestIdMock';

class MockHttpError extends Error {
  response: { status: number; requestId?: string };

  constructor(props: { status: number; response?: any }) {
    super();
    this.response = { status: props.status, requestId: MOCK_REQUEST_ID, ...props.response };
  }
}
